module.exports = __webpack_public_path__ + "static/media/polis_KASKO2.24b896b5.webp";